import { dvMarkerExtensionInstall } from './adjustRectVerticalPosition';

export default [dvMarkerExtensionInstall];
